import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toHandlers as _toHandlers, mergeProps as _mergeProps, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d0a33b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "topPage" }
const _hoisted_2 = { class: "topPage__head" }
const _hoisted_3 = { class: "search" }
const _hoisted_4 = { class: "search__input" }
const _hoisted_5 = { class: "search__head" }
const _hoisted_6 = { class: "search__simple" }
const _hoisted_7 = { class: "search__simple_button" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "searchButton__inner" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "searchButton__icon" }),
  /*#__PURE__*/_createElementVNode("span", { class: "searchButton__text" }, "さがす")
], -1))
const _hoisted_9 = { class: "search__advanced" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "searchButton__inner" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "searchButton__icon" }),
  /*#__PURE__*/_createElementVNode("span", { class: "searchButton__text" }, "くわしくさがす")
], -1))
const _hoisted_11 = { class: "search__grade" }
const _hoisted_12 = { class: "search__grade_lists" }
const _hoisted_13 = { class: "search__grade_list" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search__grade_button" }, "1・2ねんせい", -1))
const _hoisted_15 = { class: "search__grade_list" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search__grade_button" }, "3・4年生", -1))
const _hoisted_17 = { class: "search__grade_list" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search__grade_button" }, "5・6年生", -1))
const _hoisted_19 = { class: "search__grade_list" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search__grade_button" }, "中・高校生", -1))
const _hoisted_21 = { class: "topPage__body" }
const _hoisted_22 = { class: "feature__lists" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner__wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "banner__item ranking__item" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ranking__item_inner" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "ranking__item_text" }, [
        /*#__PURE__*/_createTextVNode("みんなの"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode("ランキング")
      ])
    ])
  ])
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner__wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "banner__item today__item" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "today__item_inner" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "today__item_text" }, [
        /*#__PURE__*/_createTextVNode("きょうの"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode("1さつ")
      ])
    ])
  ])
], -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "banner__wrap" }
const _hoisted_27 = { class: "banner__item nowRead__item" }
const _hoisted_28 = { class: "nowRead__item_inner" }
const _hoisted_29 = { class: "nowRead__item_box" }
const _hoisted_30 = { class: "nowRead__item_text" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("今")
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, "(", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rt", null, "いま", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, ")", -1))
const _hoisted_35 = /*#__PURE__*/_createTextVNode("読")
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, "(", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rt", null, "よ", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, ")", -1))
const _hoisted_39 = /*#__PURE__*/_createTextVNode("んで")
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", { class: "pcOnly" }, null, -1))
const _hoisted_41 = /*#__PURE__*/_createTextVNode("いる本 ")
const _hoisted_42 = /*#__PURE__*/_createTextVNode("読")
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, "(", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rt", null, "よ", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, ")", -1))
const _hoisted_46 = /*#__PURE__*/_createTextVNode("む ")
const _hoisted_47 = {
  key: 0,
  class: "recommended__title recommended__title_nextgiga"
}
const _hoisted_48 = /*#__PURE__*/_createTextVNode("読")
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, "(", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rt", null, "よ", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, ")", -1))
const _hoisted_52 = /*#__PURE__*/_createTextVNode("むことができる本 ")
const _hoisted_53 = {
  key: 1,
  class: "recommended__title"
}
const _hoisted_54 = /*#__PURE__*/_createTextVNode("新")
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, "(", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rt", null, "あたら", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, ")", -1))
const _hoisted_58 = /*#__PURE__*/_createTextVNode("しく")
const _hoisted_59 = /*#__PURE__*/_createTextVNode("入")
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, "(", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rt", null, "はい", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, ")", -1))
const _hoisted_63 = /*#__PURE__*/_createTextVNode("った本 ")
const _hoisted_64 = { class: "recommended__body" }
const _hoisted_65 = {
  key: 0,
  class: "recommended__lists"
}
const _hoisted_66 = {
  key: 0,
  class: "bookCapsule__wrap"
}
const _hoisted_67 = { key: 0 }
const _hoisted_68 = {
  key: 0,
  class: "notifications__wrap"
}

import { inject, nextTick, ref, reactive, computed, onMounted, Ref } from 'vue'
import { useRouter } from 'vue-router'

import { useReadBook } from '@/composables/useReadBook'
import { useHandleError } from '@/composables/useHandleError'
import { CANCEL_STATUS, NOTIFICATION_SCOPE } from '@/constants'
import { GA_EVENT_VALUES } from '@/constants/ga'
import { ORDERS } from '@/constants/search'
import { injectionKeys } from '@/constants/injectionKeys'
import GaHelper from '@/helpers/GaHelper'
import ValidationHelper from '@/helpers/ValidationHelper'

import {
  GetFeatureItem,
  GetYmNotificationResponseItem,
  ReadingStatusResponse,
  GetPickupItem,
  PickupList,
  GetFeatureRequest,
} from '@/models/ApiIF'

import {
  generateNumbers,
  randomNumbersNotDuplicated,
  shuffleArray,
} from '@/utils'
import { useErrorStore, BOOKSHELF_REGISTRATION } from '@/store/error'
import { useKeyboardStore } from '@/store/keyboard'
import { useLoadingStore } from '@/store/loading'

import AppButton from '@/components/AppButton/AppButton.vue'
import AppImage from '@/components/AppImage/AppImage.vue'
import AppInput from '@/components/AppInput/AppInput.vue'
import AppTooltip from '@/components/AppTooltip/AppTooltip.vue'
import Book from '@/components/Book/Book.vue'
import FeatureBanner from '@/components/FeatureBanner/FeatureBanner.vue'
import Notifications from '@/components/Notifications/Notifications.vue'
import ReadBookStatus from '@/components/ReadBookStatus/ReadBookStatus.vue'
import SearchDetails from '@/components/SearchDetails/SearchDetails.vue'
import BookCapsule from '@/components/BookCapsule/BookCapsule.vue'
import InputSettings from '@/models/InputSettings'
import ApiHelper from '@/helpers/ApiHelper'
import StoreHelper from '@/helpers/StoreHelper'
import AppEnum from '@/enums/AppEnum'
import CookieHelper from '@/helpers/CookieHelper'
import LocalStorageHelper from '@/helpers/LocalStorageHelper'
import ApiException, { exceptions } from '@/exceptions/ApiException'

// provide/inject, routerなどの共通系
interface ShowStatus {
  ReadBookStatus: boolean
  search: boolean
  feature1: boolean
  feature2: boolean
  feature3: boolean
  ranking: boolean
  today: boolean
  nowRead: boolean
  recommended: boolean
  [key: string]: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Top',
  setup(__props) {

const isUserId = inject<Ref<boolean>>(injectionKeys.isUserId)!

// check is next giga
const isNextGiga = inject<Ref<boolean>>(injectionKeys.isNextGiga)!

const loadingStore = useLoadingStore()
const $validation = inject<ValidationHelper>(injectionKeys.$validation)!
const { handleErrors } = useHandleError()

const router = useRouter()

// 要素の遅延表示
const showStatus = reactive({
  ReadBookStatus: false,
  search: false,
  feature1: false,
  feature2: false,
  feature3: false,
  ranking: false,
  today: false,
  nowRead: false,
  recommended: false,
}) as ShowStatus

let showTime = ref(200)

// 表示アニメーション
const showAnimation = () => {
  Object.keys(showStatus).forEach((key) => {
    showTime.value = showTime.value + 100
    setTimeout(() => {
      showStatus[key] = true
    }, showTime.value)
  })
}

// APIとDOMの読み込み状態
const loadDataAndDomState = ref({
  isLoadedApi: false,
  isLoadedDom: false,
})
const isLoadComplete = computed(() => {
  return (
    loadDataAndDomState.value.isLoadedApi &&
    loadDataAndDomState.value.isLoadedDom
  )
})

// 読み込み完了確認
const checkPageLoading = async () => {
  if (isLoadComplete.value) {
    // ローディング終了
    loadingStore.setLoading(false)
    // 表示
    showAnimation()
  }
}

// お知らせ
const notificationList = ref<GetYmNotificationResponseItem[]>([])
const isVisibleNotifications = ref(false)
const openNotifications = () => {
  isVisibleNotifications.value = true
}
const closeNotifications = () => {
  isVisibleNotifications.value = false
}

// フリーワード検索
const freeWord = ref('')

// さがす
const search = () => {
  if (freeWordErrorMessage.value) {
    return
  }

  const query: { [key: string]: string | number } = {
    searchType: 'freeword',
    freeWord: freeWord.value,
  }
  if (!freeWord.value) {
    query.order = ORDERS.nOrderReleaseStart.code
  }

  router.push({
    path: '/book_search',
    query,
  })
}

// くわしくさがす
const isVisibleSearchDetails = ref(false)
const openSearchDetails = () => {
  isVisibleSearchDetails.value = true
}
const closeSearchDetails = () => {
  isVisibleSearchDetails.value = false
}
const onCloseSearchDetails = () => {
  closeSearchDetails()
  if (keyboardStore.isShow) {
    focusToInput()
  }
}

// 読書状況
const readingStatus = ref<ReadingStatusResponse['readingStatus']>()
const enabledNowRead = computed(() => {
  if (!readingStatus.value) return false
  if (!readingStatus.value.readingContentsId) return false
  if (isNextGiga.value && readingStatus.value.displayStatusNextGiga == 0) {
    return false
  }
  if (readingStatus.value.cancelStatus !== CANCEL_STATUS.notCanceled.value)
    return false
  if (readingStatus.value.releaseEndFlag === 1) return false
  return true
})
const nowReadBookThumnailPath = computed(() => {
  if (!readingStatus.value) return null
  if (!readingStatus.value.readingContentsId) {
    return require('@/assets/image/top/book_starter.svg')
  }
  if (readingStatus.value.cancelStatus === CANCEL_STATUS.canceled.value) {
    return require('@/assets/image/img_book_none.svg')
  }
  return readingStatus.value.thumbnailPath
})
const canRead = computed(() => {
  if (!readingStatus.value) return false
  if (readingStatus.value.cancelStatus !== CANCEL_STATUS.notCanceled.value)
    return false
  if (readingStatus.value.releaseEndFlag === 1) return false
  if (readingStatus.value.readingContentsId) return true
  return true
})
const isReadingContentsId = computed(() => {
  if (!readingStatus.value) return false
  if (readingStatus.value.readingContentsId) return true
  return false
})

const { read, startPollingCheckReadingComplete } = useReadBook()
const errorStore = useErrorStore()
const onClickRead = async () => {
  if (!enabledNowRead.value) return
  if (!readingStatus.value?.readingContentsId) return
  read(readingStatus.value.readingContentsId)
  GaHelper.registerGaEvent(GA_EVENT_VALUES.top.readingBook)
  const errorCode = await registerBookToBookshelf()
  if (errorCode) {
    errorStore.setErrorCode(BOOKSHELF_REGISTRATION, errorCode)
  }
  startPollingCheckReadingComplete()
}

// 特集
const featureData = ref<GetFeatureItem[]>([])
const onClickFeature = (feature: GetFeatureItem) => {
  const dimensions = ['top', `${feature.id}${feature.title}`]
  return GaHelper.registerGaEvent(GA_EVENT_VALUES.feature.banner, dimensions)
}

// きょうの1さつ
const isVisibleBookCapsule = ref(false)
const onClickBookCapsule = () => {
  openBookCapsule()
  GaHelper.registerGaEvent(GA_EVENT_VALUES.top.bookCapsule)
}
const openBookCapsule = () => {
  isVisibleBookCapsule.value = true
}
const closeBookCapsule = () => {
  isVisibleBookCapsule.value = false
}

// 新しく入った本
const pickupList = ref<PickupList>({ bookList: [] })

const MAX_BOOK_LIST = 5
const bookList = computed(() => {
  if (!pickupList.value) return []
  if (!pickupList.value.bookList) return []

  // ランダム数値(index)を5コ生成
  const randomNumbers = randomNumbersNotDuplicated(
    generateNumbers(0, pickupList.value.bookList.length - 1),
    pickupList.value.bookList.length < MAX_BOOK_LIST
      ? pickupList.value.bookList.length
      : MAX_BOOK_LIST
  )
  const bookList: GetPickupItem[] = []
  for (const i of randomNumbers) {
    bookList.push(pickupList.value.bookList[i])
  }
  // シャッフル
  return shuffleArray(bookList)
})

const onClickBook = (id: GetPickupItem['contentsId']) => {
  GaHelper.registerGaEvent(GA_EVENT_VALUES.top.pickup, [id])
}

// ソフトキーボードフォーカス設定
const focusInput = ref()
const focusToInput = () => {
  focusInput.value.querySelector('input').focus()
}
const keyboardStore = useKeyboardStore()
keyboardStore.$subscribe(async (mutation, state) => {
  if (state.isShow) {
    await nextTick()
    focusToInput()
  }
})

onMounted(() => {
  // ロードフラグをtrueにする
  loadDataAndDomState.value.isLoadedDom = true
  checkPageLoading()
})

// ↓ 主にTF様の編集領域
// ------------------------------

const inputSettings: InputSettings = {
  freeword: {
    name: 'フリーワード',
    rules: {
      checkEmoji: true,
      maxLength: 129,
    },
  },
}

/**
 * お知らせ取得
 */
const getYmNotification = async () => {
  await ApiHelper.getYmNotification({ scope: NOTIFICATION_SCOPE.current.value })
    .then((res) => (notificationList.value = res.notifications))
    .then(() => {
      if (notificationList.value.length > 0) {
        openNotifications()
      }
    })
}

/**
 * 読書状況取得
 */
const getReadingStatus = async () => {
  await ApiHelper.getReadingStatus({}).then((res) => {
    readingStatus.value = res.readingStatus
  })
}

/**
 * ポイント更新
 */
const updatePoint = async () => {
  await ApiHelper.getPoint({}).then((res) => {
    StoreHelper.updatePoint(res.pointBalance)
  })
}

/**
 * 特集取得
 */
const getFeature = async () => {
  const req: GetFeatureRequest = {
    topDisplayFlag: AppEnum.topDisplayFlag.yomokkaTop.value,
    lmt: 3,
  }
  await ApiHelper.getFeature(req).then(
    (res) => (featureData.value = res.featureData)
  )
}

/**
 * ピックアップ取得
 */
const getPickupList = async () => {
  await ApiHelper.getPickupList({}).then((res) => (pickupList.value = res))
}

/**
 * ログイン後初回のみ実施
 */
const execOnlyInitialAfterLogin = async () => {
  if (CookieHelper.getYmLoginFlag()) return

  LocalStorageHelper.setViewerData()

  if (!isNextGiga.value) {
    const callGetYmNotification = getYmNotification()
    await callGetYmNotification
  }
  // const callGetYmNotification = getYmNotification()

  CookieHelper.setYmLoginFlag(true)

  // await callGetYmNotification
}

/**
 * ID認証ユーザの場合のみ実施する
 */
const execOnlyUserId = async () => {
  if (!isUserId.value) return
  const callGetReadingStatus = getReadingStatus()
  const callUpdatePoint = updatePoint()

  await callGetReadingStatus
  await callUpdatePoint
}

// 初期ロード時のAPIリクエスト
const initialRequest = async () => {
  const callOnlyInitialAfterLogin = execOnlyInitialAfterLogin()
  const callOnlyUserId = execOnlyUserId()
  const callGetFeature = getFeature()
  const callGetPickupList = getPickupList()

  await callOnlyInitialAfterLogin
  await callOnlyUserId
  await callGetFeature
  await callGetPickupList

  // ロードフラグをtrueにする
  loadDataAndDomState.value.isLoadedApi = true
  checkPageLoading()
}

const init = (async () => {
  // ローディング開始
  loadingStore.setLoading(true)
  try {
    // 初期表示用のリクエスト
    await initialRequest()
  } catch (err) {
    loadingStore.setLoading(false)
    handleErrors(err)
  }
})()

// バリデーション
const freeWordErrorMessage = computed(() => {
  return $validation.getErrorMessage(
    freeWord.value,
    inputSettings,
    'freeword',
    true,
    true
  )
})

const registerBookToBookshelf = async () => {
  try {
    await ApiHelper.registerBookshelfBook({
      contentsId: readingStatus.value!.readingContentsId!,
    })
    return null
  } catch (err) {
    if (!(err instanceof ApiException)) {
      handleErrors(err)
    }
    const errorCode = err.code
    if (errorCode === exceptions.data.alreadyProcessed.code) {
      return null
    }
    if (
      errorCode === exceptions.data.bookMaxError.code ||
      errorCode === exceptions.data.bookPositionMaxError.code
    ) {
      return errorCode
    }
    handleErrors(err)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_rb = _resolveComponent("rb")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        (_unref(isUserId))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["ReadBookStatus", 
          _unref(showStatus).ReadBookStatus ? 'anime-popIn is-active' : 'anime-popIn'
        ])
            }, [
              _createVNode(ReadBookStatus, {
                firstPage: {
            backgroundImage: require('@/assets/image/top/book_pages.svg'),
            title:
              '<ruby><rb>読</rb><rp>(</rp><rt>よ</rt><rp>)</rp></ruby >んだページ<ruby ><rb>数</rb><rp>(</rp><rt>すう</rt><rp>)</rp></ruby>',
            count: readingStatus.value?.totalReadingPage
              ? readingStatus.value.totalReadingPage
              : 0,
            unit: 'ページ',
          },
                secondPage: {
            backgroundImage: require('@/assets/image/top/book_books.svg'),
            title:
              '<ruby><rb>読</rb><rp>(</rp><rt>よ</rt><rp>)</rp></ruby>んだ本の<ruby><rb>数</rb><rp>(</rp><rt>かず</rt><rp>)</rp></ruby>',
            count: readingStatus.value?.readingCompleteCount
              ? readingStatus.value.readingCompleteCount
              : 0,
            unit: 'さつ',
          },
                loaded: _unref(isLoadComplete)
              }, null, 8, ["firstPage", "secondPage", "loaded"])
            ], 2))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(["search__inner", _unref(showStatus).search ? 'anime-popIn is-active' : 'anime-popIn'])
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", {
                    class: "search__simple_input",
                    ref_key: "focusInput",
                    ref: focusInput
                  }, [
                    _createVNode(AppInput, {
                      id: "search-free-word",
                      modelValue: freeWord.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((freeWord).value = $event)),
                      errorMessages: _unref(freeWordErrorMessage) ? [''] : [],
                      placeholder: "キーワードを入力",
                      onEnter: search
                    }, null, 8, ["modelValue", "errorMessages"])
                  ], 512),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(AppTooltip, {
                      enabled: !!_unref(freeWordErrorMessage),
                      text: _unref(freeWordErrorMessage),
                      location: "bottom"
                    }, {
                      default: _withCtx(({ listeners }) => [
                        _createElementVNode("button", _mergeProps({ class: "searchButton animationLink" }, _toHandlers(listeners), { onClick: search }), [
                          _createVNode(AppButton, null, {
                            default: _withCtx(() => [
                              _hoisted_8
                            ]),
                            _: 1
                          })
                        ], 16)
                      ]),
                      _: 1
                    }, 8, ["enabled", "text"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    class: "searchButton animationLink",
                    onClick: openSearchDetails
                  }, [
                    _createVNode(AppButton, null, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("ul", _hoisted_12, [
                  _createElementVNode("li", _hoisted_13, [
                    _createVNode(_component_router_link, {
                      to: `/book_search?searchType=grade&grade=1&order=${_unref(ORDERS).nOrderReleaseStart.code}`,
                      class: "search__grade_link animationLink"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(AppButton, { color: "grade" }, {
                          default: _withCtx(() => [
                            _hoisted_14
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _createElementVNode("li", _hoisted_15, [
                    _createVNode(_component_router_link, {
                      to: `/book_search?searchType=grade&grade=2&order=${_unref(ORDERS).nOrderReleaseStart.code}`,
                      class: "search__grade_link animationLink"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(AppButton, { color: "grade" }, {
                          default: _withCtx(() => [
                            _hoisted_16
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _createElementVNode("li", _hoisted_17, [
                    _createVNode(_component_router_link, {
                      to: `/book_search?searchType=grade&grade=3&order=${_unref(ORDERS).nOrderReleaseStart.code}`,
                      class: "search__grade_link appButton__link animationLink"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(AppButton, { color: "grade" }, {
                          default: _withCtx(() => [
                            _hoisted_18
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _createElementVNode("li", _hoisted_19, [
                    _createVNode(_component_router_link, {
                      to: `/book_search?searchType=grade&grade=4&order=${_unref(ORDERS).nOrderReleaseStart.code}`,
                      class: "search__grade_link appButton__link animationLink"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(AppButton, { color: "grade" }, {
                          default: _withCtx(() => [
                            _hoisted_20
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ])
              ])
            ])
          ], 2)
        ])
      ]),
      _createElementVNode("section", _hoisted_21, [
        _createElementVNode("div", {
          class: _normalizeClass({
          withoutNowRead: !_unref(isUserId),
          topPage__body_nextGiga: _unref(isNextGiga),
          topPage__body_inner: !_unref(isNextGiga),
        })
        }, [
          (!_unref(isNextGiga))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["feature", { withoutNowRead: !_unref(isUserId) }])
              }, [
                _createElementVNode("ul", _hoisted_22, [
                  _createElementVNode("li", {
                    class: _normalizeClass(["feature__list", 
                _unref(showStatus).feature1 ? 'anime-popIn is-active' : 'anime-popIn'
              ]),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (onClickFeature(featureData.value[0])))
                  }, [
                    (featureData.value[0])
                      ? (_openBlock(), _createBlock(FeatureBanner, {
                          key: 0,
                          feature: featureData.value[0]
                        }, null, 8, ["feature"]))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("li", {
                    class: _normalizeClass(["feature__list", 
                _unref(showStatus).feature2 ? 'anime-popIn is-active' : 'anime-popIn'
              ]),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (onClickFeature(featureData.value[1])))
                  }, [
                    (featureData.value[1])
                      ? (_openBlock(), _createBlock(FeatureBanner, {
                          key: 0,
                          feature: featureData.value[1]
                        }, null, 8, ["feature"]))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("li", {
                    class: _normalizeClass(["feature__list", 
                _unref(showStatus).feature2 ? 'anime-popIn is-active' : 'anime-popIn'
              ]),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (onClickFeature(featureData.value[2])))
                  }, [
                    (featureData.value[2])
                      ? (_openBlock(), _createBlock(FeatureBanner, {
                          key: 0,
                          feature: featureData.value[2]
                        }, null, 8, ["feature"]))
                      : _createCommentVNode("", true)
                  ], 2)
                ])
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["ranking", [
            _unref(showStatus).ranking ? 'anime-popIn is-active' : 'anime-popIn',
            !_unref(isUserId) ? 'withoutNowRead' : '',
          ]]),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(GaHelper).registerGaEvent(_unref(GA_EVENT_VALUES).top.ranking)))
          }, [
            _createVNode(_component_router_link, {
              to: "/book_ranking",
              class: "ranking__link banner__link"
            }, {
              default: _withCtx(() => [
                _hoisted_23
              ]),
              _: 1
            })
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["today", [
            _unref(showStatus).today ? 'anime-popIn is-active' : 'anime-popIn',
            !_unref(isUserId) ? 'withoutNowRead' : '',
          ]])
          }, [
            _createElementVNode("button", {
              class: "today__link banner__link",
              onClick: onClickBookCapsule
            }, _hoisted_25)
          ], 2),
          _createVNode(AppTooltip, {
            enabled: (!_unref(canRead) && _unref(isReadingContentsId)) || !_unref(enabledNowRead),
            text: "<ruby><rb>読</rb><rp>(</rp><rt>よ</rt><rp>)</rp></ruby>むことができません",
            location: "top",
            class: _normalizeClass([_unref(showStatus).nowRead ? 'anime-popIn is-active' : 'anime-popIn', "nowRead"])
          }, {
            default: _withCtx(({ listeners }) => [
              (_unref(isUserId))
                ? (_openBlock(), _createElementBlock("div", _mergeProps({ key: 0 }, _toHandlers(listeners), {
                    class: 
                _unref(enabledNowRead)
                  ? 'nowRead__link banner__link'
                  : 'nowRead__static is-inactive'
              ,
                    onClick: onClickRead
                  }), [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("p", _hoisted_30, [
                              _createElementVNode("ruby", null, [
                                _createVNode(_component_rb, null, {
                                  default: _withCtx(() => [
                                    _hoisted_31
                                  ]),
                                  _: 1
                                }),
                                _hoisted_32,
                                _hoisted_33,
                                _hoisted_34
                              ]),
                              _createElementVNode("ruby", null, [
                                _createVNode(_component_rb, null, {
                                  default: _withCtx(() => [
                                    _hoisted_35
                                  ]),
                                  _: 1
                                }),
                                _hoisted_36,
                                _hoisted_37,
                                _hoisted_38
                              ]),
                              _hoisted_39,
                              _hoisted_40,
                              _hoisted_41
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["nowRead__item_btn", { 'is-disabled': !_unref(enabledNowRead) }])
                            }, [
                              _createElementVNode("ruby", null, [
                                _createVNode(_component_rb, null, {
                                  default: _withCtx(() => [
                                    _hoisted_42
                                  ]),
                                  _: 1
                                }),
                                _hoisted_43,
                                _hoisted_44,
                                _hoisted_45
                              ]),
                              _hoisted_46
                            ], 2)
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(["nowRead__item_book", {
                        'is-inactive':
                          !readingStatus.value?.readingContentsId ||
                          readingStatus.value?.cancelStatus ===
                            _unref(CANCEL_STATUS).canceled.value,
                      }])
                          }, [
                            _createVNode(AppImage, {
                              src: 
                          _unref(nowReadBookThumnailPath)
                            ? _unref(nowReadBookThumnailPath)
                            : require('@/assets/image/img_book_none.svg')
                        ,
                              noImageSrc: require('@/assets/image/img_book_404.svg'),
                              width: "120",
                              height: "120"
                            }, null, 8, ["src", "noImageSrc"])
                          ], 2)
                        ])
                      ])
                    ])
                  ], 16))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["enabled", "class"]),
          _createElementVNode("div", {
            class: _normalizeClass(["recommended", 
            _unref(showStatus).recommended ? 'anime-popIn is-active' : 'anime-popIn'
          ])
          }, [
            (_unref(isNextGiga))
              ? (_openBlock(), _createElementBlock("h2", _hoisted_47, [
                  _createElementVNode("ruby", null, [
                    _createVNode(_component_rb, null, {
                      default: _withCtx(() => [
                        _hoisted_48
                      ]),
                      _: 1
                    }),
                    _hoisted_49,
                    _hoisted_50,
                    _hoisted_51
                  ]),
                  _hoisted_52
                ]))
              : (_openBlock(), _createElementBlock("h2", _hoisted_53, [
                  _createElementVNode("ruby", null, [
                    _createVNode(_component_rb, null, {
                      default: _withCtx(() => [
                        _hoisted_54
                      ]),
                      _: 1
                    }),
                    _hoisted_55,
                    _hoisted_56,
                    _hoisted_57
                  ]),
                  _hoisted_58,
                  _createElementVNode("ruby", null, [
                    _createVNode(_component_rb, null, {
                      default: _withCtx(() => [
                        _hoisted_59
                      ]),
                      _: 1
                    }),
                    _hoisted_60,
                    _hoisted_61,
                    _hoisted_62
                  ]),
                  _hoisted_63
                ])),
            _createElementVNode("div", _hoisted_64, [
              (_unref(bookList)?.length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_65, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bookList), (book) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: book.contentsId,
                        class: "recommended__list"
                      }, [
                        _createVNode(Book, {
                          contentsId: book.contentsId,
                          newBookFlg: book.newBookFlg,
                          thumbnailPath: book.thumbnailPath,
                          hasAction: false,
                          pattern: "small",
                          class: "card",
                          "onClick:book": onClickBook
                        }, null, 8, ["contentsId", "newBookFlg", "thumbnailPath"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ], 2)
      ])
    ]),
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (isVisibleBookCapsule.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
              _createVNode(BookCapsule, { onClose: closeBookCapsule })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (isVisibleSearchDetails.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
              _createVNode(SearchDetails, { onClose: onCloseSearchDetails })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (isVisibleNotifications.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
              _createVNode(Notifications, {
                notifications: notificationList.value,
                onClose: closeNotifications
              }, null, 8, ["notifications"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})